import {
  conversionSourceUrls,
  isHttpGateway,
  isOpcEndpoint
} from '@atbash-labs/ontology-tag-registration'
import type { AcquisitionTargetMode, TagRecord } from '@axilon-apps/domains-ontology-ui-state'

export {
  acquisitionDestinationOptions,
  conversionSourceUrls,
  isHttpGateway,
  isOpcEndpoint,
  normalizeAcquisitionUrl
} from '@atbash-labs/ontology-tag-registration'

export const ACQUISITION_HISTORY_WARNING =
  'Historical readings stay under the old source URL and will not appear on the converted tag. New samples start fresh.'

export function targetModeForSourceMode(
  sourceMode: TagRecord['scrapeMode']
): AcquisitionTargetMode | null {
  if (sourceMode === 'poll') return 'subscribe'
  if (sourceMode === 'subscribe') return 'poll'
  return null
}

export function validateConversionSourceUrls(
  targetMode: AcquisitionTargetMode,
  sourceUrl: string,
  destinationUrl: string,
  opcUsername = '',
  opcPassword = ''
): string | null {
  if (!sourceUrl.trim()) return 'The selected tags must have a source URL.'
  if (!destinationUrl.trim()) {
    return targetMode === 'subscribe'
      ? 'Destination OPC endpoint URL is required.'
      : 'Destination HTTP gateway URL is required.'
  }
  const { httpGatewayUrl, opcEndpointUrl } = conversionSourceUrls(
    targetMode,
    sourceUrl,
    destinationUrl
  )
  if (!isHttpGateway(httpGatewayUrl)) {
    return 'HTTP gateway URL must be an absolute http or https URL.'
  }
  if (!isOpcEndpoint(opcEndpointUrl)) {
    return 'OPC endpoint URL must use opc.tcp://.'
  }
  if (targetMode === 'subscribe' && opcUsername.trim() && !opcPassword) {
    return 'OPC password is required when a username is set.'
  }
  return null
}
